export default class TableOptions {
  constructor(pagination, filters) {
    if (!pagination) {
      this.search = ''
      this.sortBy = []
      this.sortDesc = []
      this.pagination = {
        page: 1,
        limit: 20,
      }
      this.page = 1
      this.totalItems = 1
      this.total = 1
      this.itemsPerPage = 20
    } else {
      if (filters.cfFilter) {
        const hasValue = function findValue(){
          let searchKeys = Object.keys(filters.cfFilter[0])
          let searchKeysDeep = Object.keys(filters.cfFilter[0][searchKeys[0]])
          if ('value' in filters.cfFilter[0][searchKeys[0]]) return filters.cfFilter[0][searchKeys[0]].value
          if ('value' in filters.cfFilter[0][searchKeys[0]][searchKeysDeep[0]]) return filters.cfFilter[0][searchKeys[0]][searchKeysDeep[0]].value
          if ('value' in filters.cfFilter[0][searchKeys[1]]) return filters.cfFilter[0][searchKeys[1]].value
          if ('value' in filters.cfFilter[0][searchKeys[1]][searchKeysDeep[0]]) return filters.cfFilter[0][searchKeys[1][searchKeysDeep[0]]].value
        }
        this.search = hasValue()
      } else if (filters.search) {
        this.search = filters.search
      } else if (filters?.custom_filter?.search) {
        this.search = filters.custom_filter.search
      } else {
        this.search = ''
      }

      this.sortBy = filters.sortBy || []
      this.sortDesc = filters.sortDesc || []
      this.pagination = {
        page: pagination.currentPage,
        limit: pagination.limit,
      }
      this.itemsPerPage = pagination.limit
      this.page = pagination.currentPage
      this.totalItems = pagination.maxPageNumber
      this.total = pagination.total
    }
  }

  static defaultTableOptions() {
    return new TableOptions()
  }

  removeDefaultSortValues(valuesArray = []) {
    valuesArray.forEach(value => {
      const valueIndex = this.sortBy.indexOf(value)
      this.sortDesc = this.sortDesc.filter((value, index) => index !== valueIndex)
    })

    this.sortBy = this.sortBy.filter(value => !valuesArray.includes(value))
  }
}
